import React, { useRef } from "react";
import { Autocomplete, TextField, Checkbox, Chip } from "@mui/material";
import AutocompleteArrow from "../AutocompleteDropdownArrow";
import "./index.css";
import filledCheck from "../../assets/yfs-label-retrieve/filled-check.svg";
import unfilledCheck from "../../assets/yfs-label-retrieve/unfilled-check.svg";

const EditableMultiSelectAutocomplete = ({
  chosen,
  classStyle = "multi-select-react-azilis",
  setValue,
  options,
  styleNo = 1,
  scrollLeft = 0,
  disabled = false,
  edit = true,
}) => {
  const SEPARATOR = "||";
  const divRef = useRef();

  const parseChosen = (value) => {
    if (typeof value === "string") {
      return value ? value.split(SEPARATOR) : [];
    }
    return value || [];
  };

  const handleChange = (_, newValue) => {
    const stringValue = newValue.map((item) => item.value).join(SEPARATOR);
    setValue(stringValue);
  };

  const selectedOptions = parseChosen(chosen).map(
    (value) =>
      options.find((opt) => opt.value === value) || { title: value, value }
  );

  return (
    <div className="w-100" ref={divRef}>
      <Autocomplete
        className={classStyle + " azilisdropdownstyle" + styleNo}
        classNamePrefix="selectprefixazilis"
        multiple
        value={selectedOptions}
        onChange={handleChange}
        options={options}
        getOptionLabel={(option) => option.title}
        disabled={disabled || !edit}
        disableCloseOnSelect
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            size="small"
            className="multi-select-input"
          />
        )}
        renderOption={(props, option, { selected }) => (
          <li {...props} className="multi-select-option">
            {option.title}
            <Checkbox
              icon={
                <img
                  src={unfilledCheck}
                  alt="Unfilled Checkbox"
                  width={18}
                  height={18}
                />
              }
              checkedIcon={
                <img
                  src={filledCheck}
                  alt="Filled Checkbox"
                  width={18}
                  height={18}
                />
              }
              checked={selected}
              className="multi-select-checkbox"
            />
          </li>
        )}
        popupIcon={<AutocompleteArrow />}
        classes={{
          paper: "dropdown-bg-custom",
        }}
        componentsProps={{
          paper: {
            sx: {
              width: 300,
              //   backgroundColor: "rgba(33, 55, 97, 0.6)",
              //   color: "white",
            },
          },
          clearIndicator: {
            sx: {
              color: "white",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            },
          },
        }}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              {...getTagProps({ index })}
              key={option.value}
              label={option.title}
              sx={{
                color: "white",
                maxWidth: "120px",
                "& .MuiChip-label": {
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                },
                margin: "2px",
                height: "24px",
                "& .MuiChip-deleteIcon": {
                  fontSize: "18px",
                },
              }}
            />
          ))
        }
        sx={{
          "& .MuiAutocomplete-tag": {
            margin: "2px",
          },
          "& .MuiAutocomplete-inputRoot": {
            paddingRight: "0",
            flexWrap: "wrap",
            gap: "2px",
            minHeight: "38px",
            "& .MuiAutocomplete-input": {
              width: "auto",
              flexGrow: 1,
              minWidth: "50px",
            },
          },
          "&.MuiAutocomplete-hasClearIcon .MuiOutlinedInput-root": {
            paddingRight: "0",
          },
          "&.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiOutlinedInput-root":
            {
              paddingRight: "18px",
            },
        }}
      />
    </div>
  );
};

export default EditableMultiSelectAutocomplete;
